import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import { store } from "@/store";
import { AppRouter } from "@/router/AppRouter";
import { UserProvider } from "@/contexts/UserContext";
import { NotificationProvider } from "@/contexts/NotificationContext";
import { SidebarProvider } from "@/contexts/SidebarContext";
import { GeneralProvider } from "@/contexts/GeneralContext";
import { MapGLProvider } from "@/contexts/MapGLContext";
import { FeedbackToastProvider } from "@/contexts/FeedbackToastContext";
import "@/utils/i18n";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

/**
 * Main Application Component
 * 
 * This component follows SOLID principles:
 * - Single Responsibility: Only handles app structure and context providers
 * - Open/Closed: Easy to extend with new providers
 * - Dependency Inversion: Uses dependency injection for routing
 */
function App() {
  return (
    <Provider store={store}>
      <Router>
        <div className="min-h-screen bg-ds-dark">
          <UserProvider>
            <NotificationProvider>
              <SidebarProvider>
                <GeneralProvider>
                  <MapGLProvider>
                    <FeedbackToastProvider>
                      <AppRouter />
                    </FeedbackToastProvider>
                  </MapGLProvider>
                </GeneralProvider>
              </SidebarProvider>
            </NotificationProvider>
          </UserProvider>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
            toastClassName="bg-ds-card border border-ds-border"
            bodyClassName="text-ds-text"
          />
        </div>
      </Router>
    </Provider>
  );
}

export default App;